import { validationRules } from 'components/Base/Form';

export const hasESADocumentationFormFields = {
  requiredBecauseOfDisability: {
    name: 'requiredBecauseOfDisability',
    rules: [validationRules.required()],
  },
};
